export const ENABLE_CREDIT_CARD_START = 'ENABLE_CREDIT_CARD_START';
export const ENABLE_CREDIT_CARD_SUCCESS =
  'ENABLE_CREDIT_CARD_SUCCESS';
export const ENABLE_CREDIT_CARD_ERROR = 'ENABLE_CREDIT_CARD_ERROR';
export const CLEAR_ENABLE_CREDIT_CARD_STORE =
  'CLEAR_ENABLE_CREDIT_CARD_STORE';
